import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import flattenObj, { NestingStringKeyObject } from './flattenObj';
import { defaultMessages, UiLanguageKey } from './languages';

type Options = {
  onError?: () => void;
};

export default function useMessages(key: UiLanguageKey, options: Options) {
  const { data: messages, error } = useQuery<NestingStringKeyObject, Error>(
    ['messages', key],
    () => {
      return import(/* webpackChunkName: "messages-[request]" */ `./messages/${key}.json`).then(
        messages => messages.default,
      );
    },
    {
      keepPreviousData: true,
      onError: options.onError,
      retry: false,
    },
  );

  const flatMessages = useMemo(() => {
    if (!messages) {
      return undefined;
    }

    return {
      ...defaultMessages,
      ...flattenObj(messages, '.'),
    };
  }, [messages]);

  return {
    data: flatMessages,
    error,
  };
}
